import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-card-selection-item',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './card-selection-item.html',
  styleUrl: './card-selection-item.scss',
})
export class CardSelectionItem {
  @Output() selectedRoutes = new EventEmitter<{link: string, title: string}>();
  @Input() img!: string;
  @Input() title!: string;
  @Input() description?: string;
  @Input() link!: string;
  @Input() size: 'default' | 'small' = 'default';

  constructor() {}

  onCardClick(): void {
    if (this.link) {
      this.selectedRoutes.emit({
        link: this.link, title: this.title
      });
    }
  }
}
